import { generatePDFFromTemplate } from './pdfGenerator';
import { generateExcelFromTemplate } from './excelGenerator';
import { notifySuccess, notifyError } from '@config/tostifyConfig/tostifyConfig';

/**
 * Helper function to generate PDF reports for any module
 * @param {Function} reportService - Function that returns report data
 * @param {Object} config - Report configuration
 * @param {Function} setLoading - Optional loading state setter
 */
export const generateReportPDF = async (reportService, config, setLoading = null) => {
    try {
        if (setLoading) setLoading(true);
        
        const result = await reportService();
        const reportData = result?.reportData ?? result;
        const reportConfig = result?.reportConfig ?? config;
        await generatePDFFromTemplate(reportData, reportConfig);
        
        notifySuccess('PDF отчет генериран успешно!');
    } catch (error) {
        const errorMessage = error?.message || 'Failed to generate PDF report';
        console.error('Error generating PDF:', error);
        notifyError(`Грешка при генериране на PDF: ${errorMessage}`);
    } finally {
        if (setLoading) setLoading(false);
    }
};

/**
 * Helper function to generate Excel reports for any module
 * @param {Function} reportService - Function that returns report data
 * @param {Object} config - Report configuration
 * @param {Function} setLoading - Optional loading state setter
 */
export const generateReportExcel = async (reportService, config, setLoading = null) => {
    try {
        if (setLoading) setLoading(true);
        
        const reportData = await reportService();
        await generateExcelFromTemplate(reportData, config);
        
        notifySuccess('Excel отчет генериран успешно!');
    } catch (error) {
        const errorMessage = error?.message || 'Failed to generate Excel report';
        console.error('Error generating Excel:', error);
        notifyError(`Грешка при генериране на Excel: ${errorMessage}`);
    } finally {
        if (setLoading) setLoading(false);
    }
};

/**
 * Creates a report configuration object for common report types
 * @param {string} title - Report title
 * @param {Array} columns - Column configuration
 * @param {string} fileName - Export file name
 * @param {string} companyName - Company name for header
 * @param {Object} customStyles - Optional custom styles for PDF
 */
export const createReportConfig = (title, columns, fileName, companyName = '', customStyles = {}) => {
    return {
        title,
        columns,
        exportFileName: fileName,
        companyName,
        customStyles
    };
};
